import { PermissionT } from "../types";

export const powurNecessities = (permissions: PermissionT[]): boolean => {
  const permission = permissions.find(({ name }) => name === "powur_necessities");
  return !!permission;
};

export default powurNecessities;
